import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {PaymentCategorySystem} from "../../utils/types/payment_categories";
import {transactionPaymentCategory_template} from "./transactionPaymentCategory_template";
import {vn_app_zone_notification} from "../../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export abstract class transactionPaymentCategoryBase_template extends vnTemplate {


    public parent: transactionPaymentCategory_template;

    public readonly allFields = [
        "systemId",
        "systemName",
        "categoryId",
        "categoryName",
        "categoryWeight",
        "commissionFormatTypeId",
        "sessionFormatTypeId",
        "usSessionFormatTypeId",
        "isDeleted",
        "dateRange",
        "editorCommissionAmount",
        "editorCommissionMin",
        "editorCommissionMax",
        "writerCommissionAmount",
        "writerCommissionMin",
        "writerCommissionMax",
        "editorSessionAmount",
        "editorSessionMin",
        "editorSessionMax",
        "writerSessionAmount",
        "writerSessionMin",
        "writerSessionMax",
        "editorUsSessionAmount",
        "editorUsSessionMin",
        "editorUsSessionMax",
        "writerUsSessionAmount",
        "writerUsSessionMin",
        "writerUsSessionMax"
    ];
    public readonly modifiableFields = [
        "categoryName",
        "categoryWeight",
        "isDeleted",
        "dateRange",
        "editorCommissionAmount",
        "editorCommissionMin",
        "editorCommissionMax",
        "writerCommissionAmount",
        "writerCommissionMin",
        "writerCommissionMax",
        "editorSessionAmount",
        "editorSessionMin",
        "editorSessionMax",
        "writerSessionAmount",
        "writerSessionMin",
        "writerSessionMax",
        "editorUsSessionAmount",
        "editorUsSessionMin",
        "editorUsSessionMax",
        "writerUsSessionAmount",
        "writerUsSessionMin",
        "writerUsSessionMax"
    ];

    protected abstract getTemplateName(): string;
    protected abstract getTemplateHtml(): string;


    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-form-body"];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            system: ko.observable(PaymentCategorySystem.NEWSANDACCESS),
            paymentCategories: ko.observableArray([]),
            onClickCancel: (data, event) => {
                self.onClickCancel();
            },
            onClickSave: (data, event) => {
                self.onClickSave();
            },
            onAddPaymentCategory: (data, event) => {
                self.onAddPaymentCategory();
            }
        };
    }

    protected initPartial() {}

    public setParent(parent: transactionPaymentCategory_template): void {
        this.parent = parent;
    }

    public setSystem(system: string): void {
        this.getTemplateViewModel().system(system);
    }

    public getSystem(): string {
        return this.getTemplateViewModel().system();
    }

    private isModifiableField(fieldName: string): boolean {
        return this.modifiableFields.indexOf(fieldName) >= 0;
    }

    setTransactionPaymentCategoriesFromServer(paymentCategories): void {
        let index = 0;
        let newList = [];
        for (let paymentCategory of paymentCategories) {

            paymentCategory['index'] = index;

            for (let field of Object.keys(paymentCategory)) {

                if (this.isModifiableField(field)) {
                    paymentCategory[`original${field}`] = paymentCategory[field];
                    paymentCategory[field] = ko.observable(paymentCategory[field]);
                } else {
                    paymentCategory[field] = paymentCategory[field];
                }
            }
            newList.push(paymentCategory);
            index++;
        }

        this.setTransactionPaymentCategories(newList);
    }

    public setTransactionPaymentCategories(paymentCategories): void {

        this.getTemplateViewModel().paymentCategories(paymentCategories);
    }


    public getPostRequestData() {

        let paymentCategories = this.getTemplateViewModel().paymentCategories();
        let paymentCategoryPostData = [];
        for (let paymentCategory of paymentCategories) {
            let newObj = {
                categoryId: paymentCategory["categoryId"],
            };

            for (let field of this.modifiableFields) {
                if (ko.isObservable(paymentCategory[field])) {
                    newObj[field] = paymentCategory[field]();
                } else {
                    newObj[field] = paymentCategory[field];
                }
            }

            paymentCategoryPostData.push(newObj);
        }

        return {
            filterBySystem:  this.parent.isFilterBySystem(),
            system: this.getTemplateViewModel().system(),
            paymentCategories: paymentCategoryPostData
        };
    }

    public getGetRequestData() {

        return {
            filterBySystem:  this.parent.isFilterBySystem(),
            system: this.getTemplateViewModel().system()
        };
    }

    public resetTransactionPaymentCategories(): void {

        let paymentCategories = this.getTemplateViewModel().paymentCategories();

        let newList = [];
        for (let paymentCategory of paymentCategories) {
            let newObj = {};
            for (let field of this.allFields) {

                if (this.isModifiableField(field)) {
                    paymentCategory[field] = ko.observable(paymentCategory[`original${field}`]);
                } else {
                    paymentCategory[field] = paymentCategory[field];
                }
            }
            newList.push(paymentCategory);
        }

        this.getTemplateViewModel().paymentCategories([]);
        this.getTemplateViewModel().paymentCategories(newList);
    }

    public removeNewAddedPaymentCategories(): void {

        let paymentCategories = this.getTransactionPaymentCategories();
        let newList = [];
        for (let paymentCategory of paymentCategories) {
            if (paymentCategory.categoryId != null) {
                newList.push(paymentCategory);
            }
        }
        this.setTransactionPaymentCategories(newList);
    }

    public getTransactionPaymentCategories() {

        return this.getTemplateViewModel().paymentCategories();
    }

    public onClickCancel(): void {

        this.caller.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Action canceled!");
        this.caller.getVnAppZone().showNotificationToModule();
        this.caller.releaseLock();
        this.resetTransactionPaymentCategories();
        this.removeNewAddedPaymentCategories();
    }

    public onClickSave(): void {
        this.caller.save();
    }

    public onAddPaymentCategory(): void {

        let system = this.getTemplateViewModel().system();
        let systemId = (system === PaymentCategorySystem.PERFORMANCE)
            ? 2
            : (system === PaymentCategorySystem.RESOURCE ? 3 : 1);
        let paymentCategories = this.getTransactionPaymentCategories();
        let index = paymentCategories.length;

        let paymentCategory = this.createNewPaymentCategory(index, systemId, system);
        paymentCategories.push(paymentCategory);

        this.setTransactionPaymentCategories(paymentCategories);
    }

    private createNewPaymentCategory(index, systemId: number, system) {

        // Default Session Range changed to 15 for all systems
        let dateRange = 15;
        return {
            index: index,
            systemId: systemId,
            systemName: system,
            categoryId: null,
            categoryName: ko.observable(null),
            formatTypeId: ko.observable(null),
            categoryWeight: ko.observable(1),
            isDeleted: ko.observable(0),
            dateRange: ko.observable(dateRange),
            editorCommissionAmount: ko.observable(null),
            editorCommissionMin: ko.observable(null),
            editorCommissionMax: ko.observable(null),
            writerCommissionAmount: ko.observable(null),
            writerCommissionMin: ko.observable(null),
            writerCommissionMax: ko.observable(null),
            editorSessionAmount: ko.observable(null),
            editorSessionMin: ko.observable(null),
            editorSessionMax: ko.observable(null),
            writerSessionAmount: ko.observable(null),
            writerSessionMin: ko.observable(null),
            writerSessionMax: ko.observable(null),
            editorUsSessionAmount: ko.observable(null),
            editorUsSessionMin: ko.observable(null),
            editorUsSessionMax: ko.observable(null),
            writerUsSessionAmount: ko.observable(null),
            writerUsSessionMin: ko.observable(null),
            writerUsSessionMax: ko.observable(null),
            onRemovePaymentCategory: (data) => this.onDeleteAddedPaymentCategory(data)
        };
    }

    public onDeleteAddedPaymentCategory(data): void {

        let newList = [];
        let paymentCategories = this.getTransactionPaymentCategories();
        for (let paymentCategory of paymentCategories) {
            if (paymentCategory.index !== data.index) {
                newList.push(paymentCategory);
            }
        }
        this.setTransactionPaymentCategories(newList);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionPaymentCategoryBase_template.ts